import { createPlugin, createRoutableExtension } from '@backstage/core-plugin-api';

import { ROOT_ROUTE_REF } from './routes';

export const deployNextAppPlugin = createPlugin({
  id: 'deploy-next-app',
  routes: {
    root: ROOT_ROUTE_REF,
  },
});

export const DeployNextAppPage = deployNextAppPlugin.provide(
  createRoutableExtension({
    name: 'DeployNextAppPage',
    component: () => import('./pages/DnaMainView').then((m) => m.DnaMainView),
    mountPoint: ROOT_ROUTE_REF,
  }),
);
